export enum TASK_ATTRIBUTES {
    Completed = "completed",
    Count = "count",
    Current = "current",
    Date = "date",
    Empty = "empty",
    Failed = "failed",
    Feature = "feature",
    FileSizeBytes = "file_size_bytes",
    FileType = "file_type",
    FileVersion = "file_version",
    FingerprintId = "fingerprint_id",
    FirmwareDate = "firmware_date",
    IncludedFileIds = "included_file_ids",
    IncludeJ1939 = "include_j1939",
    Message = "message",
    Order = "order",
    Password = "password",
    PasswordSource = "password_source",
    Pending = "pending",
    Price = "price",
    ProtocolId = "protocol_id",
    ReportedCount = "reported_count",
    RequestedCount = "requested_count",
    Revision = "firmware_version",
    SameGradeFileIds = "same_grade_file_ids",
    Start = "start",
    VehicleId = "vehicle_id",
    Vin = "vin"
}
